import React from 'react';

import { productFormsMachineTags } from '../../../product/constants/formMachineConstants';
import { MultiStepSubmitSectionProps } from '../../types/MultiStepRegistrationFormTypes';
import { isAuthenticationStep } from '../../utils/MultiStepSuccessStepUtils';
import {
  ButtonComponent,
  buttonSize,
  ButtonSize,
  buttonVariant,
  ButtonVariant
} from '../ButtonComponent';
import MultiStepVerifyOTP from '../MultiStepVerifyOtpButton';
import {
  SubmitButtonFrame,
  SubmitButtonText,
  SubmitButtonTextWrapper
} from '../MultiStepSubmitButtonContent/styledComponents';

export const MultiStepSubmitSection: React.FC<MultiStepSubmitSectionProps> = ({
  currentStepType,
  stepId,
  nextBtnId,
  nextBtnText,
  nextBtnActions,
  formValues,
  customClassNames,
  publicFormMachineState,
  publicFormMachineSend,
  designSystemType,
  otpFieldRef,
  onClickNextBtn
}) => {
  const isSubmitButtonLoading = (): boolean => {
    if (
      publicFormMachineState.context.shouldShowGetOTP &&
      publicFormMachineState.hasTag(productFormsMachineTags.otpVerifyBtnLoading)
    ) {
      return false;
    }

    return publicFormMachineState.context.isNextAndSubmitBtnLoading;
  };

  const isSubmitButtonDisabled = (): boolean => {
    if (designSystemType === 'SHADCN_DESIGN_SYSTEM') {
      return false;
    }

    if (
      publicFormMachineState.context.shouldShowGetOTP &&
      !publicFormMachineState.context.isLoggedIn
    ) {
      return true;
    }

    return false;
  };

  if (isAuthenticationStep(currentStepType)) {
    if (!otpFieldRef) {
      return null;
    }

    return (
      <MultiStepVerifyOTP
        otp={formValues['otp'] as string}
        otpFieldRef={otpFieldRef}
        nextStepButtonId={nextBtnId}
        nextStepButtonText={nextBtnText}
        publicFormMachineSend={publicFormMachineSend}
        nextBtnActions={nextBtnActions}
        formValues={formValues}
        publicFormMachineState={publicFormMachineState}
        customClassNames={customClassNames}
        designSystemType={designSystemType}
      />
    );
  }

  return (
    <ButtonComponent
      id={nextBtnId}
      isDisabled={isSubmitButtonLoading() || isSubmitButtonDisabled()}
      isLoading={isSubmitButtonLoading()}
      type={'button'}
      variant={buttonVariant.primary as ButtonVariant}
      size={buttonSize.large as ButtonSize}
      onClick={onClickNextBtn}
      className={customClassNames.nextAndSubmitButton}
      shouldShrinkButtonWhileLoading={false}
      designSystemType={designSystemType}
    >
      <SubmitButtonTextWrapper className={`${stepId}-text-wrapper`}>
        <SubmitButtonFrame className={`${stepId}-frame`}></SubmitButtonFrame>
        <SubmitButtonText className={`${stepId}-text`}>
          {nextBtnText}
        </SubmitButtonText>
      </SubmitButtonTextWrapper>
    </ButtonComponent>
  );
};
